import { render, staticRenderFns } from "./line-charts-data-labels.vue?vue&type=template&id=5c98e87a"
import script from "./line-charts-data-labels.vue?vue&type=script&lang=js"
export * from "./line-charts-data-labels.vue?vue&type=script&lang=js"
import style0 from "./line-charts-data-labels.vue?vue&type=style&index=0&id=5c98e87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports